import React, { useContext, useEffect, useState } from 'react';

import { GlobalContext } from '../../store';
import { ITeam } from '../../store/admin/eventTeams/store';
import { IAdminTeamGame } from '../../store/admin/teamGames/store';

import {
  useTeamsCreatorDispatch,
  useTeamsCreatorState
} from '../../scenes/admin/EventWizard/TeamsCreator/Context/TeamsCreator.context';
import { TeamCardMetadata } from './TeamCardMetadata/TeamCardMetadata';
import PlayerCard from '../PlayerCard/PlayerCard';
import { EmptySpot } from './EmptySpot/EmptySpot';
import { useRouteInfoState } from '../RouteInfo/Context/RouteInfo.context';
import { TeamCardStyled } from './TeamCard.Styles';
import { useGetAdminEvent } from '../../contrib/Hooks/useGetAdminEvent';

export type TTeamCardContext = 'teams' | 'tee' | 'teeListSelector' | 'flights';
interface ITeamCard {
  context: TTeamCardContext;
  displayChangeTeamFlight?: boolean;
  hideActions?: boolean;
  team: ITeam;
  teamGame?: IAdminTeamGame;
}

export const TeamCard = (props: ITeamCard) => {
  const { team, hideActions, displayChangeTeamFlight, context, teamGame } = props;

  const {
    actions: {
      adminEventTeams: { update: updateAdminEventTeam }
    },
    adminEventRounds: { current: round }
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const { enrollments, editMode, selectedTeam } = useTeamsCreatorState();
  const { dispatch } = useTeamsCreatorDispatch();

  const onRemovePlayer = (enrollmentId: number) => () => {
    const newEnrollments = team.enrollments.filter(enrollment => enrollment !== enrollmentId);

    updateAdminEventTeam(clubId, eventId, team.id, {
      enrollments: newEnrollments
    });

    dispatch({ type: 'resetEditModeEnrollmentId' });
    dispatch({ type: 'updateSelectedTeamEnrollments', value: newEnrollments });
  };

  const onOpenSpot = () => {
    dispatch({ type: 'openTeamPlayerSelectorModal' });
  };

  const event = useGetAdminEvent(eventId);

  const playersPerTeam = event && event.playersPerTeam ? event.playersPerTeam : 2;

  const emptySpots =
    playersPerTeam - team.enrollments.length > 0 ? playersPerTeam - team.enrollments.length : 0;

  const [thisTeamEditMode, setThisTeamEditMode] = useState(false);

  useEffect(() => {
    setThisTeamEditMode(editMode && !!selectedTeam && selectedTeam.id === team.id);
  }, [editMode, selectedTeam]);

  return (
    <TeamCardStyled elevation={1} className={`paper team-card ${team.isValid ? '' : 'invalid'}`}>
      <TeamCardMetadata
        context={context}
        team={team}
        hideActions={hideActions}
        teamGame={teamGame}
        displayChangeTeamFlight={displayChangeTeamFlight}
      />

      {team.enrollments.map(
        enrollment =>
          enrollments[enrollment] &&
          round && (
            <PlayerCard
              item={enrollments[enrollment]}
              key={`team-${team.id}-playerCard-${enrollment}`}
              context={{
                onRemovePlayer:
                  thisTeamEditMode && !context.includes('tee') ? onRemovePlayer : undefined,
                round
              }}
            />
          )
      )}

      {[...Array(emptySpots).keys()].map((index: number) => (
        <EmptySpot
          key={`openSpot-${team.id}-${index}`}
          onClick={thisTeamEditMode ? onOpenSpot : undefined}
          editMode={thisTeamEditMode}
        />
      ))}
    </TeamCardStyled>
  );
};
